const toggleMenuBurger = () => {
    document.getElementById('menu-burger').classList.toggle('hidden');
}

export function create() {
    document.getElementById('menu-burger-btn').addEventListener('click', toggleMenuBurger);
}